import { StepLabel, stepLabelClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomStepLabel = styled(StepLabel)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  cursor: "pointer",
  [`& .${stepLabelClasses.label}`]: {
    marginTop: theme.spacing(1),
    textAlign: "center",
    color: "#FFFFFF80",
    fontSize: "1.2em"
  },
  [`& .${stepLabelClasses.label}.${stepLabelClasses.active}`]: {
    color: "#FFF",
    fontSize: "1.5em",
    fontWeight: "500",
  },
  [`& .${stepLabelClasses.label}.${stepLabelClasses.completed}`]: {
    color: "#FFFFFF80",
    fontSize: "1.2em",
  }
}));

export default CustomStepLabel;